import PropTypes from 'prop-types'
import {Badge} from 'reactstrap'
import Shield from 'react-feather/dist/icons/shield.js'
import Radio from 'react-feather/dist/icons/radio.js'
import Key from 'react-feather/dist/icons/key.js'
import Edit from 'react-feather/dist/icons/edit.js'
import Trash from 'react-feather/dist/icons/trash.js'
import FileMinus from 'react-feather/dist/icons/file-minus.js'

import {clearanceTypes, getClearanceLabel, getDisplayClearanceStatus} from '../../services/clearanceConstants.js'

import './ClearanceListItem.scss'

const typeIcons = {
  [clearanceTypes.defense.value]: Shield,
  [clearanceTypes.radiation_protection.value]: Radio,
  [clearanceTypes.site_access.value]: Key,
}

export default function ClearanceListItem({clearance, freelanceId, onEdit, onDelete}) {
  const TypeIcon = typeIcons[clearance.type]
  const status = getDisplayClearanceStatus(clearance)
  const documentUrl = clearance.supporting_document
    ? `${process.env.API_URL}/freelances/${freelanceId}/clearances/${clearance.id}/document`
    : null

  return (
    <div className="clearance-list-item callout">
      <div className="clearance-list-item-icon">
        <TypeIcon/>
      </div>
      <div className="clearance-list-item-label">
        <b>{getClearanceLabel(clearance)}</b>
        {!clearance.supporting_document &&
          <span className="clearance-list-item-no-document" title="Aucun justificatif n'a été fourni pour cette habilitation">
            <FileMinus size={14}/> Non justifiée
          </span>
        }
        {documentUrl &&
          <a href={documentUrl} target="_blank" rel="noopener noreferrer" className="clearance-list-item-document-link">
            Voir le justificatif
          </a>
        }
      </div>
      {status && <Badge color={status.badgeColor} className="clearance-list-item-badge text-white">{status.label}</Badge>}
      <div className="clearance-list-item-controls">
        <button
          type="button"
          onClick={() => onEdit(clearance)}
          className="btn btn-outline-primary btn-round btn-sm"
        >
          <Edit/>
        </button>
        <button
          type="button"
          onClick={() => onDelete(clearance)}
          className="btn btn-outline-danger btn-round btn-sm ml-2"
        >
          <Trash/>
        </button>
      </div>
    </div>
  )
}

ClearanceListItem.propTypes = {
  clearance: PropTypes.object.isRequired,
  freelanceId: PropTypes.number.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}
